daterangepicker.prototype.getStartDate = function () {
  return this.startDate?.clone();
};

daterangepicker.prototype.getEndDate = function () {
  return this.endDate?.clone();
};
